import { useMemo, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { listFiltersService, ListTableSort, SortOrder } from "sprint-common-web";

export interface ResolutionsListingFilters {
    page: number;
    pageSize: number;
    name: string;
    sortBy: string;
    sortOrder: SortOrder;
}

const defaultFilters: ResolutionsListingFilters = {
    name: "",
    page: 1,
    pageSize: 50,
    sortBy: "",
    sortOrder: "asc"
};

export const useResolutionsListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<ResolutionsListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<ResolutionsListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: ResolutionsListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: ResolutionsListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: ResolutionsListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    const setName = (name: string): void => {
        setFilters((prevFilters: ResolutionsListingFilters) => ({ ...prevFilters, name, page: 1 }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setName,
        setSort,
        setPage,
        setPageSize,
        clearFilters
    };
};
